import React from 'react';
export var TabsContent = function TabsContent(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-Tabs"
  }, children);
};